import IProfileInitiativeStatus from 'types/sign-in/IProfileInitiativeStatus'
import { InitiativesSelectorDialogOpenState } from './State'

export const SET_IS_DIALOG_OPEN = 'initiativeSelectorDialog.setIsDialogOpen'
export const SET_INITIATIVES_OPTIONS = 'initiativeSelectorDialog.setInitiativesOptions'
export const TOGGLE_IS_LOADING = 'initiativeSelectorDialog.toggleIsLoading'
export const RESET = 'initiativeSelectorDialog.reset'

export function setIsDialogOpen(payload: InitiativesSelectorDialogOpenState) {
  return {
    type: SET_IS_DIALOG_OPEN,
    payload
  } as const
}

export function setInitiativesOptions(
  isOpenState: InitiativesSelectorDialogOpenState,
  options: IProfileInitiativeStatus[]
) {
  return {
    type: SET_INITIATIVES_OPTIONS,
    payload: {
      isDialogOpenState: isOpenState,
      initiativesOptions: options
    }
  } as const
}

export function toggleIsLoading() {
  return {
    type: TOGGLE_IS_LOADING,
    payload: {}
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type InitiativeSelectorDialogActions = ReturnType<
  typeof setIsDialogOpen | typeof setInitiativesOptions | typeof reset | typeof toggleIsLoading
>
